<mat-form-field class="muntinsSelect" *ngIf="(hardwareSets$ | async).length > 0">
    <mat-label>{{ 'DOOR|Zestaw osprzętu' | translate }}</mat-label>
    <mat-select (selectionChange)="changeSet($event)" [value]="hardwareSetSelect$ | async">
        <mat-option *ngFor="let set of (hardwareSets$ | async) || []" [value]="set">
            <ng-container [ngSwitch]="set">
                <ng-container *ngSwitchCase="'none'">{{ 'INTERFACE|Brak' | translate }}</ng-container>
                <ng-container *ngSwitchCase="'doubleLever'">{{ 'DOOR|Klamka - klamka' | translate }}</ng-container>
                <ng-container *ngSwitchCase="'leverKnob'">{{ 'DOOR|Klamka - gałka' | translate }}</ng-container>
                <ng-container *ngSwitchCase="'leverPull'">{{ 'DOOR|Klamka - pochwyt' | translate }}</ng-container>
            </ng-container>
        </mat-option>
    </mat-select>
</mat-form-field>
<icc-select-box
    [title]="'DOOR|Przystosowanie pod pochwyt' | translate"
    [description]="(doorHandleAdjustment$ | async)?.name"
    [imageUrl]="'/files/windowaccessory/' + ((doorHandleAdjustment$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="changeDoorHandleAdjustment()"
    *ngIf = "(showWindowLeverBox$ | async) && (showDoorHandleAdjustmentBox$ | async)"
></icc-select-box>
<icc-select-box
    [title]="'DOOR|Typ osprzętu' | translate"
    [description]="(selectedHardwareType$ | async)?.name"
    [imageUrl]="'/files/windowaccessory/' + ((selectedHardwareType$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [buttonText2]="(selectedHardwareType$ | async)?.id && ('INTERFACE|Opcje' | translate)"
    (select)="selectType()"
    (select2)="changeTypeOptions()"
    *ngIf = "showWindowLeverBox$ | async"
    [descriptionTemplate]="typeBoxTemplate"
    [descriptionContext]="hardwareTypeBoxSelect"
></icc-select-box>
<icc-select-box
    *ngIf = "(pull$ | async) && (hardwareSet$ | async) === 'leverPull' && ((doorHandleAdjustment$ | async)?.id && (showWindowLeverBox$ | async) || !(showWindowLeverBox$ | async))"
    [title]="'DOOR|Pochwyt' | translate"
    [imageUrl]="'/files/windowaccessory/' + ((pull$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [buttonText2]="isPullColorRelatedToPlate !== true ? ('INTERFACE|Opcje' | translate) : false"
    (select)="changePull()"
    (select2)="openPullsOptions()"
    [descriptionTemplate]="pullBoxTemplate"
    [descriptionContext]="pullBoxSelect"
    [disabledButton1]="isPullButtonDisabled()"
    [disabledButton2]="isPullButton2Disabled()"
    ></icc-select-box>
<icc-select-box
    [title]="'DOOR|Typ elektronicznej wkładki' | translate"
    [description]="(electronicLock$ | async)?.name"
    [imageUrl]="'/files/windowaccessory/' + ((electronicLock$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="changeElectronicLock()"
    *ngIf = "(selectedHardwareType$ | async)?.electronic_door_lock"
></icc-select-box>
<icc-select-box
    [title]="'DOOR|Typ oszyldowania' | translate"
    [description]="(plateType$ | async)?.name"
    [imageUrl]="'/files/windowaccessory/' + ((plateType$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="changePlateType()"
    *ngIf = "(showWindowLeverBox$ | async) && (selectedHardwareType$ | async)?.id"
></icc-select-box>
<icc-select-box
    *ngIf=" ((plateMainLock$ | async) || (plateAdditionalLock$ | async)) && !(showWindowLeverBox$ | async) && (hardwareSet$ | async)"
    [title]="'DOOR|Szyldy' | translate"
    [imageUrl]="(platesBoxSelect?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="openPlatesOptions()"
    [descriptionTemplate]="platesBoxTemplate"
    [descriptionContext]="platesBoxSelect"
    [disabledButton1]="isPlatesButtonDisabled()"
></icc-select-box>
<icc-select-box
    *ngIf="(lock$ | async)"
    [title]="'DOOR|Zamek' | translate"
    [description]="(lock$ | async)?.name"
    [imageUrl]="'/files/windowaccessory/' + ((lock$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="changeLock()"
    [descriptionTemplate]="locksBoxTemplate"
    [descriptionContext]="lockBoxSelect"
    [disabledButton1]="isLockButtonDisabled()"
></icc-select-box>
<icc-select-box
    [title]="'DOOR|Wkładki' | translate"
    [imageUrl]="(cylindersBoxSelect?.cylinders.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="openCylindersOptions()"
    *ngIf = "!(showWindowLeverBox$ | async) && (hardwareSet$ | async) && isCylinderBoxVisible()"
    [descriptionTemplate]="cylindersBoxTemplate"
    [descriptionContext]="cylindersBoxSelect"
></icc-select-box>
<icc-select-box
    [title]="'DOOR|Wizjer' | translate"
    [description]="(doorViewer$ | async)?.name"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [imageUrl]="(doorViewer$ | async)?.img ? ('/files/windowaccessory/' + ((doorViewer$ | async)?.img)) : '/img/door/wizjer_brak.jpg'"
    (select)="changeDoorViewer()"
    *ngIf="(showDoorViewer$ | async)"
    [disabledButton1]="isDoorViewerButtonDisabled()"
></icc-select-box>
<icc-select-box
    *ngIf="(hinge$ | async)"
    [title]="'DOOR|Zawiasy' | translate"
    [description]="(hinge$ | async)?.name"
    [imageUrl]="'/files/windowaccessory/' + ((hinge$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="changeHinges()"
    [disabledButton1]="isHingeButtonDisabled()"
></icc-select-box>
<icc-select-box
    [title]="'DOOR|Ozdobne nakładki zawiasów' | translate"
    [description]="(decorativeHingeCoversColor$ | async)?.name"
    [color]="'#' + (decorativeHingeCoversColor$ | async)?.color"
    [imageUrl]="'/files/windowhandlescolor/' + ((decorativeHingeCoversColor$ | async)?.color_img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="changeDecorativeHingeCover()"
    *ngIf="((showDecorativeHingeCovers$ | async) && (decorativeHingeCoversColor$ | async))"
    [colorSelect]="true"
    [disabledButton1]="isDecorativeHingeCoverButtonDisabled()"
></icc-select-box>

<mat-slide-toggle
    (change)="changeDoorViewerPunching($event)"
    [checked]="doorViewerPunching$ | async"
    *ngIf="!(showWindowLeverBox$ | async) && (doorViewer$ | async)?.id && (showDoorViewerPunchingOption$ | async)"
>
    {{ 'DOOR|Otworowanie pod wizjer' | translate }}
</mat-slide-toggle>

<ng-template #typeBoxTemplate let-name="name" let-color="color" let-description="description">
    <p> <b>{{ 'DOOR|Typ osprzętu:' | translate }}</b> {{name || ('INTERFACE|Brak' | translate)}}</p>
    <p *ngIf="color">
        <b>{{ 'COLOR|Kolor:' | translate }}</b> {{color}}
    </p>
    <p ng-bind-html="description"></p>
</ng-template>


<ng-template #platesBoxTemplate let-mainLockName="mainLockName" let-additionalLockName="additionalLockName" let-color="color" let-description="description">
    <p *ngIf="mainLockName"> <b>{{ 'DOOR|Typ szyldu zamka głównego' | translate }}</b> {{mainLockName}}</p>
    <p *ngIf="additionalLockName"> <b>{{ 'DOOR|Typ szyldu zamka dodatkowego' | translate }}</b> {{additionalLockName}}</p>
    <p *ngIf="color">
        <b>{{ 'COLOR|Kolor:' | translate }}</b> {{color}}
    </p>
    <p ng-bind-html="description"></p>
</ng-template>

<ng-template #cylindersBoxTemplate let-cylinders="cylinders">
    <p *ngIf="cylinders?.mainLockName"> <b>{{ 'DOOR|Rodzaj wkładki zamka głównego' | translate }}</b> {{cylinders.mainLockName}}</p>
    <p *ngIf="cylinders?.additionalLockName"> <b>{{ 'DOOR|Rodzaj wkładki zamka dodatkowego' | translate }}</b> {{cylinders.additionalLockName}}</p>
    <p *ngIf="cylinders?.system"> <b>{{ 'DOOR|System wkładek' | translate }}</b> {{cylinders.system}}</p>
    <p *ngIf="cylinders?.electronicLock"> <b>{{ 'DOOR|Typ elektronicznej wkładki'   | translate }}</b> {{cylinders.electronicLock}}</p>
    <p ng-bind-html="description"></p>
</ng-template>

<ng-template #pullBoxTemplate let-pull="pullType" let-color="color">
    <p> <b>{{ 'DOOR|Typ pochwytu' | translate }}</b> {{ pullBoxSelect.pullType?.name }} </p>
    <p *ngIf="pullBoxSelect.pullType?.color"> <b>{{ 'COLOR|Kolor:' | translate }}</b> {{ pullBoxSelect.pullType?.color}} </p>
</ng-template>

<ng-template #locksBoxTemplate let-lock="lock">
    <p> <b>{{ 'DOOR|Typ zamka' | translate }}</b> {{ lockBoxSelect.lock.name }} </p>
</ng-template>